import {
  FilterOperationType,
  FilterType,
} from '@/components/Table/Table.constants';
import type { Filter } from '@/components/Table/Table.types';

import type { CustomPopulation } from '../CustomPopulation.types';

export const formatClsNumberFilter = (
  values: Nullable<CustomPopulation['filters']['currentCLS']>,
  propertyName: string
): Nullable<Filter> => {
  if (!values) return null;

  const start = values.lowerDisabled ? null : parseInt(values.lowerValue);
  const end = values.upperDisabled ? null : parseInt(values.upperValue);

  let normalizedValues;

  switch (values.filterType) {
    case FilterOperationType.BETWEEN:
      normalizedValues = { end, start };
      break;
    case FilterOperationType.GREATER_THAN:
      normalizedValues = { value: start };
      break;
    case FilterOperationType.LESS_THAN:
      normalizedValues = { value: end };
      break;
    default:
      return null;
  }

  return {
    operationType: values.filterType,
    propertyName,
    type: FilterType.NUMBER,
    ...normalizedValues,
  } as Filter;
};
